import { CookieMonster } from 'root/utils/cookies/cookieMonster';
/*eslint no-unused-labels: "off"*/ //this rule is not working from .eslintrc

type CookieMonsterObject = {
    setCookie: (a: string, b: string) => void;
    getCookie: (a: string) => string;
};

type BusinessTypeLexicData = {
    name: string;
    link: string;
    clear_business_type_text: string;
    slug: string;
};

type BusinessTypeObject = {
    [key: number]: BusinessTypeLexicData;
};
type GlobalLexic =
    | [
          {
              business_types: BusinessTypeObject;
              link: string;
              name: string;
              product: string;
          }
      ]
    | undefined;

declare global {
    interface Window {
        btfNavSecondaryLexic: GlobalLexic;
    }
}
/*
The script sets a cookie based on the slug that's inserted dynamically on the body tag.
It retrieves the cookie, and dynamically changes the links in the nav in order to reflect the cookie value.
*/
function getCurrentCookieValue(
    cm: CookieMonsterObject,
    cookieName: string,
    cookieValue: string
) {
    const consentCallback = () => {
        const body = document.body;
        const verticalSlug = body.dataset.verticalSlug;
        if (verticalSlug) {
            const isCookieDifferentThanSlug = cookieValue && verticalSlug !== cookieValue;
            // Set business type cookie if the ls_vertical_bt cookie is undefined/null OR
            // the vertical slug is different from the ls_vertical_bt value.
            if (!cookieValue || isCookieDifferentThanSlug) {
                /* Set the cookie - make sure that the path is always "/" or
                    else a secondary cookie will be set and the functionality will break */
                {
                    cm.setCookie(cookieName, verticalSlug);
                }
            }
        }
    };
    (<any>window).registerCookieComplianceCallback({ callback: consentCallback });

    const body = document.body;
    const verticalSlug = body.dataset.verticalSlug;
    if (verticalSlug) {
        const isCookieDifferentThanSlug = cookieValue && verticalSlug !== cookieValue;
        // Set business type cookie if the ls_vertical_bt cookie is undefined/null OR
        // the vertical slug is different from the ls_vertical_bt value.
        if (!cookieValue || isCookieDifferentThanSlug) {
            /* Set the cookie - make sure that the path is always "/" or
                else a secondary cookie will be set and the functionality will break */
            {
                cm.setCookie(cookieName, verticalSlug);
            }
        }
    }
    return cm.getCookie(cookieName);
}
function getVerticalBusinessTypeSpecificLexic(
    businessTypeValue: string,
    globalLexicVar: GlobalLexic
) {
    if (globalLexicVar && globalLexicVar.length > 0 && globalLexicVar[0].business_types) {
        if (typeof Object.values === 'function') {
            /* this is a fix for "TypeError: Object.values is not a function" recurrent error in DD */

            const btArray = Object.values(globalLexicVar[0].business_types);

            return (
                btArray &&
                btArray.find(function ({ slug }) {
                    return slug === businessTypeValue;
                })
            );
        }
    }
}

export default function navigationSecondary(navs: NodeList) {
    const cm = new CookieMonster();
    const btCookieName = 'ls_vertical_bt';
    const btCookieValue = cm.getCookie(btCookieName);
    const navHeader = document.querySelector('header.main-site-header-btf');

    setPreviousCookieValueInLocalStorage: {
        btCookieValue && window.localStorage.setItem('btf.businessType', btCookieValue);
    }
    navs.forEach((nav: HTMLElement) => {
        const isCurrentSecondaryNav =
            window.getComputedStyle(nav).getPropertyValue('display') !== 'none';

        const globalLexicVar = window.btfNavSecondaryLexic;
        const isGlobalLexicVar =
            globalLexicVar && globalLexicVar.length > 0 && globalLexicVar[0] !== null;
        const secondaryMobileNav: HTMLElement | null = nav.querySelector(
            '.navigation-btf-mobile__secondary'
        );
        checkForSecondaryMobileNav: {
            nav = secondaryMobileNav ? secondaryMobileNav : nav;
        }
        const isSecondary =
            nav.classList.contains('navigation-btf-desktop--secondary') ||
            secondaryMobileNav;

        /* make sure that the nav is not hidden and it is a secondary nav.
        The loop goes through the main desktop nav, the secondary desktop nav and the main mobile nav,
        which has the mobile secondary nav as a child */
        if (isCurrentSecondaryNav && isSecondary && isGlobalLexicVar) {
            const businessTypeLexicData = getVerticalBusinessTypeSpecificLexic(
                getCurrentCookieValue(cm, btCookieName, btCookieValue),
                globalLexicVar
            );
            const desktopItemSelector = 'navigation-btf-desktop__item';
            /* Based on that the cookie will be set/unset */
            navHeader?.setAttribute(
                'data-slug-match',
                businessTypeLexicData ? 'true' : 'false'
            );

            if (businessTypeLexicData) {
                const secondaryNavIndexButton: HTMLAnchorElement | null =
                    nav.querySelector('[data-secondary-nav-index-button]');
                const secondaryNavHeaderIndex: HTMLAnchorElement | null =
                    nav.querySelector('[data-secondary-nav-header-index]');
                const secondaryNavClearButton: HTMLAnchorElement | null =
                    nav.querySelector('[data-secondary-nav-clear-bt]');

                const {
                    name,
                    link,
                    clear_business_type_text: clearButtonText,
                } = <BusinessTypeLexicData>(<unknown>businessTypeLexicData);
                /* Change the name and the link of the business type menu item in the secondary nav
                 * for instance: Apparel, or Bike..
                 * */
                if (name && link) {
                    if (secondaryNavIndexButton) {
                        secondaryNavIndexButton.innerText = name;
                        secondaryNavIndexButton.href = link;
                        /* Set the index link to active if on vertical page, but remove if not */
                        secondaryNavIndexButton.parentElement?.classList.toggle(
                            `${desktopItemSelector}--active`,
                            window.location.href.includes(link)
                        );
                    }
                    if (secondaryNavHeaderIndex) {
                        secondaryNavHeaderIndex.innerText = name;
                        secondaryNavHeaderIndex.href = link;
                    }
                }
                if (secondaryNavClearButton) {
                    /* insert the "Not a <BT> yours?" text into the element */
                    if (clearButtonText) {
                        secondaryNavClearButton.innerText = clearButtonText;
                        secondaryNavClearButton.classList.remove(
                            `${desktopItemSelector}__link--hidden`
                        );
                        secondaryNavClearButton.removeAttribute('tabindex');
                    }
                }
            }

            showSecondaryNavItemsOnDesktop: {
                nav.querySelector('[data-secondary-nav-middle-group]')?.classList.remove(
                    `${desktopItemSelector}-group-middle--hidden`
                );
            }

            showSecondaryNavItemsOnMobile: {
                nav.querySelector('[data-secondary-nav-header]')?.classList.remove(
                    'navigation-btf-mobile__menu__list--hidden'
                );
            }
        }
    });
}
